export const CP_UPDATE_APPOINTMENT = 'CP_UPDATE_APPOINTMENT';

export const CP_UPDATE_APPOINTMENT_SUCCESS = 'CP_UPDATE_APPOINTMENT_SUCCESS';

export const CP_UPDATE_APPOINTMENT_FAILED = 'CP_UPDATE_APPOINTMENT_FAILED';